export const SECRET = 'qGC68iSqjQ3axMgv1Dck32boPCl3sAua7urPor1T'
